import { render, staticRenderFns } from "./Banned.vue?vue&type=template&id=79aa8410"
import script from "./Banned.vue?vue&type=script&lang=js"
export * from "./Banned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports